import { NARRATIVE_OWNER_FRAGMENT } from '@/components/NarrativeAuthor';
import { gql } from '@/utilities/gql';

export const NARRATIVE_FRAGMENT = gql(
  `
  fragment NarrativeFields on Narrative @_unmask {
    companyId
    contentBlocks {
      contentHtml
      id
      title
    }
    id
    slug
    title
    valuation {
      discountRate
      fairValue
      futurePePercentageChange
      futureSharesOutstanding
      profitMarginPercentageChange
      revenuePercentageChange
      timeframe
      sharesOutstandingGrowthRate
      fiscalData {
        mostRecentReportedDate
        yearlyTimeSeries {
          year
          data {
            netIncome
            revenue
            endDate
            totalSharesOutstanding
          }
        }
      }
      exchangeRate
    }
    userHoldsPosition
    owner {
      ...NarrativeOwnerFields
    }
    isPrimary
  }
`,
  [NARRATIVE_OWNER_FRAGMENT]
);
